const styles = theme => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    padding: '20px',
    background: theme.palette.primary.white,
    '& $ownerAvatarimg': {
      marginRight: '16px',
      height: '64px',
      width: '64px',
      background: '#EBEEF3',
    },
    '& $textRow': {
      paddingBottom: '0',
    },
    '& h3': {
      fontSize: '16px',
      fontWeight: '700',
      color: '#130F26',
    },
    '& h6': {
      fontSize: '14px',
      fontWeight: '400',
      color: '#595B61',
    },
  },
  ownerAvatarimg: {},
  applicationId: {
    padding: '20px',
  },
});

export default styles;
